module.exports = "<span> <noscript> <iframe src=\"//www.googletagmanager.com/ns.html?id=GTM-53TJNNP\" height=0 width=0 style=display:none;visibility:hidden></iframe> </noscript> <script>!function(e,t,a,n,g){e[n]=e[n]||[],e[n].push({\"gtm.start\":(new Date).getTime(),event:\"gtm.js\"});var m=t.getElementsByTagName(a)[0],r=t.createElement(a);r.async=!0,r.src=\"//www.googletagmanager.com/gtm.js?id=GTM-53TJNNP\",m.parentNode.insertBefore(r,m)}(window,document,\"script\",\"dataLayer\")</script> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/directives/gtm/gtm.html
// module id = 859
// module chunks = 0